<template>
  <v-card>
    <v-card-text>
		<v-form ref="drugForm">
			<v-row no-gutters>
        <v-col cols="12" sm="6">
          <v-text-field
						v-model="drug.name"
						:label="$gettext('Name')"
						filled
						class="px-2"
						:rules="required"
					></v-text-field>
				</v-col>
        <v-col cols="12" sm="6">
          <v-text-field
						v-model="drug.generic_name"
						:label="$gettext('Generic Name')"
						filled
						class="px-2"
						:rules="required"
					></v-text-field>
				</v-col>
        <v-col cols="12" sm="6">
          <v-text-field
						v-model="drug.farm_formula"
						:label="$gettext('Presentation')"
						filled
						class="px-2"
            :rules="required"
					></v-text-field>
				</v-col>
        <v-col cols="12" sm="6">
          <v-text-field
						v-model="drug.dosage"
						:label="$gettext('Dosage')"
						filled
						class="px-2"
					></v-text-field>
				</v-col>
        <v-col cols="12" sm="6">
          <v-text-field
						v-model="drug.owner"
						:label="$gettext('Owner')"
						filled
						class="px-2"
					></v-text-field>
				</v-col>
        <v-col cols="12" sm="6">
          <v-autocomplete
						v-model="drug.farm_groups"
						:items="farmGroups"
						filled
            small-chips
            deletable-chips
						:label="$gettext('Farm Groups')"
						item-text="name"
						item-value="id"
						multiple
            hide-details
            hide-no-data
            class="px-2"
					>
            <template slot="item" slot-scope="data">
              {{ data.item.code }} - {{ data.item.name }}
            </template>
          </v-autocomplete>
				</v-col>
        <v-col cols="12" sm="6">
          <v-checkbox
						v-model="drug.is_generic"
						class="mt-0 pt-0"
						color="primary"
						dense
						:label="$gettext('Generic')"
					>
					</v-checkbox>
        </v-col>
        <v-col cols="12" class="py-5">
          <v-btn-toggle class="ml-2" v-model="language" mandatory>
						<v-btn v-for="l in languages" :value="l.value" small class="text-overline" :key="l.value">
							<strong class="mr-1">{{l.value}}</strong>
							<span>{{l.text}}</span>
						</v-btn>
					</v-btn-toggle>
        </v-col>
        <v-col cols="12">
          <v-textarea
						filled
						:label="$gettext('Indications')"
						:placeholder="' '"
						v-model="drug.extra_info[language].indications"
					></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-textarea
						filled
						:label="$gettext('Contraindications')"
						:placeholder="' '"
						v-model="drug.extra_info[language].contraindications"
					></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-textarea
						filled
						:label="$gettext('Secondary Effects')"
						:placeholder="' '"
						v-model="drug.extra_info[language].secundary_effects"
					></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-alert v-model="success" color="alert" type="success">
						<translate>Saved Successfully</translate>
					</v-alert>
					<v-alert v-model="error" color="red" type="error">
						<translate>Error</translate>
						<span>{{errorMessage}}</span>
					</v-alert>
        </v-col>
			</v-row>
		</v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="primary" text :to="{name: 'drugs'}">
				<translate>Cancel</translate>
			</v-btn>
      <v-spacer></v-spacer>
			<v-btn
        depressed
				color="secondary"
        class="primary--text"
				@click="saveDrug"
				:loading="saving"
			>
				<span v-if="edit" v-translate>Save</span>
        <span v-else v-translate>Create</span>
			</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "DrugForm",
  props: ["drug", "edit"],
  data: () => ({
    saving: false,
    success: false,
    error: false,
    errorMessage: "Erro",
    language: 'pt'
  }),
  computed: {
    farmGroups() {
      return this.$store.getters.farmGroups;
    },
    required() {
      return [v => !!v || this.$gettext("Required.")]
    },
    languages() {
      return [
        {value: 'pt', text: this.$gettext('Portuguese')},
        {value: 'en', text: this.$gettext('English')},
        {value: 'es', text: this.$gettext('Spanish')}
      ]
    }
  },
  methods: {
    getForm() {
      if(this.$refs.drugForm.validate()) {
        const form = new FormData();
        form.append("name", this.drug.name.toLowerCase());
        form.append("generic_name", this.drug.generic_name.toLowerCase());
        form.append("farm_formula", this.drug.farm_formula);
        form.append("dosage", this.drug.dosage);
        form.append("is_generic", this.drug.is_generic);
        form.append("owner", this.drug.owner);
        this.languages.forEach(l => {
          form.append("indications_" + l.value, this.drug.extra_info[l.value].indications);
          form.append("contraindications_" + l.value, this.drug.extra_info[l.value].contraindications);
          form.append("secundary_effects_" + l.value, this.drug.extra_info[l.value].secundary_effects);
				});
        form.append("farm_groups_json", JSON.stringify(this.drug.farm_groups));
        return form;
      }
      return false;
    },
    saveDrug() {
      this.error = false;
      this.success = false;
      this.errorMessage = "Erro";
      let form = this.getForm();
      if(form) {
        this.saving = true;
        let endpoint;
        if(this.edit) endpoint = "/drugs/" + this.drug.id + "/edit";
        else endpoint = "/drugs/new";
        axios
					.post(endpoint, form)
					.then(response => {
						console.log(response.data);
						this.saving = false;
						if (response.data.result == "ok") {
							this.success = true;
              this.drug = response.data.drug;
              if(!this.edit) this.$router.push({name: 'drugs'});
            } else {
							this.error = true;
							this.errorMessage = response.data.error;
						}
					})
					.catch(error => {
						this.saving = false;
						this.error = true;
						console.log(error);
					});
      }
    }
  },
  created() {
    this.$store.dispatch('GET_FARM_GROUPS');
  }
}
</script>